import React from 'react';
import { formatDateLabel } from './chartUtils';

const tooltipStyle = {
    backgroundColor: '#fff',
    border: '1px solid #ddd',
    borderRadius: '4px',
    padding: '10px',
    boxShadow: '0 2px 4px rgba(0,0,0,0.1)'
};

const dotStyle = (color) => ({
    display: 'inline-block',
    width: '10px',
    height: '10px',
    backgroundColor: color,
    marginRight: '8px',
    borderRadius: '2px'
});

/**
 * Tooltip compartido para charts (line y bar).
 * Espera que cada entry en payload tenga opcionalmente `${dataKey}_formatted` y `${dataKey}_label`
 * en entry.payload para mostrar valores formateados y labels limpios.
 */
export function ChartTooltip({ active, payload, label, seriesMap }) {
    if (!active || !payload || payload.length === 0) return null;

    return (
        <div style={tooltipStyle}>
            <p style={{ margin: '0 0 8px 0', fontWeight: 'bold' }}>{formatDateLabel(label)}</p>
            {payload.map((entry, index) => {
                const dataKey = entry.dataKey;
                const seriesInfo = seriesMap ? seriesMap[dataKey] : null;

                const displayValue = entry.payload[`${dataKey}_formatted`] !== undefined
                    ? entry.payload[`${dataKey}_formatted`]
                    : entry.value !== null && entry.value !== undefined
                        ? entry.value.toLocaleString()
                        : '-';

                let seriesLabel = seriesInfo ? seriesInfo.label : entry.name || dataKey;
                const baseName = seriesLabel.replace(/\s*-\s*Período\s+(Actual|Comparación)\s*$/i, '').trim();
                const isComparison = seriesInfo && seriesInfo.period === 'comparison';
                seriesLabel = isComparison ? `${baseName} (ant.)` : baseName;

                return (
                    <p key={index} style={{ margin: '4px 0', color: entry.color }}>
                        <span style={dotStyle(entry.color)}></span>
                        {seriesLabel}: <strong>{displayValue}</strong>
                    </p>
                );
            })}
        </div>
    );
}
